// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PePm","col":"styles_col__2gBfq"};